import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase"
import { ENV } from "../env"

// Check if analytics should be tracked (only in production)
const shouldTrackAnalytics = () => {
  return ENV === "production";
};

// Utility function to track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (!shouldTrackAnalytics()) {
    console.log(`[Analytics] Skipped in ${ENV}:`, eventName, parameters);
    return;
  }

  try {
    logEvent(analytics, eventName, parameters);
    console.log(`[Analytics] Tracked:`, eventName, parameters);
  } catch (error) {
    console.warn("Analytics tracking failed:", error);
  }
};

// Common event tracking functions
export const trackPageView = (pageName) => {
  trackEvent("page_view", {
    page_title: pageName,
    page_location: window.location.href,
  });
};

export const trackButtonClick = (buttonName, location = "") => {
  trackEvent("button_click", {
    button_name: buttonName,
    location: location,
  });
};

export const trackFormSubmit = (formName) => {
  trackEvent("form_submit", {
    form_name: formName,
  });
};

export const trackUserAction = (action, details = {}) => {
  trackEvent("user_action", {
    action: action,
    ...details,
  });
};
